// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F6QA","newExpiryDate":"styles_newExpiryDate__ZUXeg","footer":"styles_footer__2fa7x"};